import { Status, UserModel } from "./user.model";

export class PatientPhysician {
  DoctorName: string;
}

export class Patient {
  FirstName: string;
  LastName: string;
  MiddleName: string;
  Dob: string;
  BirthDay: number;
  BirthMonth: string;
  BirthYear: string;
  Gender: string;
  UserId?: number;
  Id?: number;
  Suffix?: string;
  Ethnicity?: string;
  CaseType?: string;
  Status?: Status;
  Physician?: PatientPhysician;
  LocationId?: number;
  LocationName?: string;
  PhlebotomistId?: number;
  PhlebotomistName?: string;
  DoctorId?: number;
  DoctorName?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  Zip?: string;
  BillToText?: string;
  Provider?: string;
  PlanNumber?: string;
  GroupNumber?: string;
  Incomplete?: boolean;
  Email?: string;
  InsurancePolicies?: any[] = [{ BillTo: '' }];
  Systems?:  [
    {
      Id: string;
      Facilities?: [
        {
          Id: string;
        }
      ]
    }
  ];
  Address? = {
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    Zip: "",
    County: "",
    Country: ""
  };
  PhoneNumbers? = {
    Home: "",
    Office: "",
    Mobile: "",
    Other: ""
  };

  constructor(params: any = {}) {
    this.Email = params.Email || null;
    this.Status = params.Status || null;
    this.UserId = params.UserId || null;

    this.Id = params.Id || "";
    this.FirstName = params.FirstName || "";
    this.LastName = params.LastName || "";
    this.MiddleName = params.MiddleName || "";

    this.Suffix = params.Suffix || null;
    this.Gender = params.Gender || null;
    this.State = params.State || null;
    this.Ethnicity = params.Ethnicity || null;
    this.CaseType = params.CaseType || null;

    this.BirthDay = params.BirthDay || null;
    this.BirthMonth = params.BirthMonth || null;
    this.BirthYear = params.BirthYear || null;
    this.Dob = params.Dob || null;

    this.LocationId = params.LocationId || null;
    this.LocationName = params.LocationName || null;

    this.DoctorId = params.DoctorId || null;
    this.DoctorName = params.DoctorName || null;

    this.PhlebotomistId = params.PhlebotomistId || null;
    this.PhlebotomistName = params.PhlebotomistName || null;
    this.Systems = params.Systems || null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/patient.model.ts